import { Injectable } from '@angular/core';
import * as msal from '@azure/msal-browser';
import { endpoint } from '@tekman/onmat/constants';
import { ApiService, EnvironmentService } from '@tekman/onmat/service/generic';
import { FeaturitWrapperService } from '@tekman/onmat/service/onmat';
import { FeaturitEventActivity } from '@tekman/shared/models';

@Injectable({
  providedIn: 'root',
})
export class TeamsService {
  constructor(
    private readonly apiService: ApiService,
    private readonly featuritlService: FeaturitWrapperService,
    private readonly env: EnvironmentService
  ) {}
  username = '';
  msalConfig = {
    auth: {
      clientId: this.env.settings?.social.microsoft.clientId,
      authority: 'https://login.microsoftonline.com/common/',
      redirectUri: window.location.origin + '/',
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };

  loginRequest = {
    scopes: ['User.Read', 'Team.ReadBasic.All'],
  };

  tokenRequest = {
    scopes: ['User.Read', 'Team.ReadBasic.All'],
    forceRefresh: false,
  };
  myMSALObj = new msal.PublicClientApplication(this.msalConfig);

  async microsoftLogin() {
    try {
      await this.myMSALObj.initialize();
      const test = await this.myMSALObj.loginPopup(this.loginRequest);
      this.track('mteams_open', 'groups');
      await this.handleResponse(test);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  track(eventKey: string, path: string) {
    const trackingProps: FeaturitEventActivity<string> = new FeaturitEventActivity({
      ui_path: path,
    });
    this.featuritlService.track(eventKey, trackingProps);
  }

  async handleResponse(response): Promise<boolean> {
    try {
      if (response !== null) {
        this.username = response.account.username;
        localStorage.setItem('mteams_username', this.username);
        await this.seeProfile();
        await this.seeJoinedTeams();
        return true;
      } else {
        this.selectAccount();
        return true;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async seeProfile(): Promise<boolean> {
    try {
      const token = await this.getTokenPopup(this.loginRequest);
      await this.callMSGraph(endpoint.external.teamsGraphMeEndpoint, token ? token?.accessToken : '', this.updateUI);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async seeJoinedTeams(): Promise<boolean> {
    try {
      const token = await this.getTokenPopup(this.loginRequest);
      await this.callMSGraph(endpoint.external.teamsGraphJoinedTeams, token ? token?.accessToken : '', this.updateUI);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async getTeamsMembers(classId): Promise<any> {
    try {
      const token = await this.getTokenPopup(this.loginRequest);
      const teachers = await this.callMSGraph(
        this.apiService.replaceUrl(endpoint.external.teamsOwners, '{classId}', classId),
        token ? token?.accessToken : '',
        (data, endpoint) => data.value
      );
      const members = await this.callMSGraph(
        this.apiService.replaceUrl(endpoint.external.teamsStudents, '{classId}', classId),
        token ? token?.accessToken : '',
        (data, endpoint) => data.value
      );
      return { members, teachers };
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  updateUI(data, endpoint) {
    localStorage.setItem(endpoint, data.value ? JSON.stringify(data.value) : JSON.stringify(data));
  }

  callMSGraph(endpoint, token, callback) {
    const headers = new Headers();
    const bearer = `Bearer ${token}`;
    headers.append('Authorization', bearer);
    const options = {
      method: 'GET',
      headers: headers,
    };
    return fetch(endpoint, options)
      .then(response => response.json())
      .then(response => callback(response, endpoint))
      .catch(error => console.log(error));
  }
  async getTokenPopup(request) {
    request.account = await this.myMSALObj.getAccountByUsername(localStorage.getItem('mteams_username'));
    await this.myMSALObj.initialize();
    return this.myMSALObj.acquireTokenSilent(request).catch(error => {
      console.warn('silent token acquisition fails. acquiring token using popup');
      if (error instanceof msal.InteractionRequiredAuthError) {
        return this.myMSALObj
          .acquireTokenPopup(request)
          .then(tokenResponse => {
            return tokenResponse;
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        console.warn(error);
      }
    });
  }
  selectAccount() {
    const currentAccounts = this.myMSALObj.getAllAccounts();
    if (currentAccounts.length === 0) {
      return;
    } else if (currentAccounts.length > 1) {
      console.warn('Multiple accounts detected.');
    } else if (currentAccounts.length === 1) {
      this.username = currentAccounts[0].username;
    }
  }
}
